module.exports = __webpack_public_path__ + "media/404.7329c9c7fe.png";